import { createSelector } from "reselect";
import get from "lodash/get";

const getCustomers = state => state.firestore.ordered.customers;
const getRegions = state => state.firestore.data.regions;
const getEquipments = state => state.firestore.data.equipments;
const getAgreements = state => state.firestore.data.agreements;
const getCustomer = (state, props) => {
  const customers = state.firestore.data.customers;
  return customers && customers[props.match.params.id];
};

const getValue = (collection, docId) => {
  return get(get(collection, docId), "name");
};

export const getCustomerList = createSelector(
  [getCustomers, getRegions, getEquipments],
  (customers, regions, equipments) => {
    return (
      regions &&
      customers &&
      customers.filter(customer => {
        if (customer.system) return false;

        const equipmentsArr =
          customer &&
          customer.equipments &&
          customer.equipments.map(equipment => {
            const equipmentName = getValue(equipments, equipment.typeId);
            return Object.assign({}, equipment, {
              name: equipmentName,
            });
          });

        return Object.assign({}, customer, {
          regionName:  'Test', // regions && getValue(regions, customer.regionId),
          equipments: equipmentsArr,
        });
      })
    );
  }
);

export const getCustomerDetails = createSelector(
  [getCustomer, getRegions, getEquipments, getAgreements],
  (customer, regions, equipments, agreements) => {
    const regionName = regions && getValue(regions, customer.regionId);

    const equipmentsList =
      customer &&
      customer.equipments &&
      customer.equipments.map(equipment => {
        const equipmentName = getValue(equipments, equipment.typeId);
        const agreementType = getValue(agreements, equipment.agreement);
        return Object.assign({}, equipment, {
          name: equipmentName,
          agreementType: agreementType,
        });
      });

    return Object.assign({}, customer, {
      regionName: regionName,
      equipments: equipmentsList,
    });
  }
);
